import React, { useRef, useState } from "react";
import { Box } from "@mui/material";
import Carousel from "react-multi-carousel";
import ReactPlayer from "react-player";
import "./BannerCarousel.scss"; // old design SCSS retained

import { PUJA_INFO_DETAILS_BANNER, PUJALOADIMG } from "../../utils/Constants";
import ImageView from "../ImageView/ImageView";
import ImageModalCarousel from "../dialog/ImageModalCarousel";
import CustomVideoPlayer from "../videoPlayer/CustomVideoPlayer";

function BannerCarouselWithVideo(props: any) {
  const { imageArray } = props;

  const [activeVideoUrl, setActiveVideoUrl] = useState<number | null>(null);
  const [overlayVisible, setOverlayVisible] = useState<boolean>(true);
  const [isCarouselAutoPlay, setIsCarouselAutoPlay] = useState<boolean>(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const mainCarouselRef = useRef<any>(null);

  const handleAfterChange = () => {
    setActiveVideoUrl(null);
  };

  const handleOverlayClick = (index: number) => {
    setOverlayVisible(false);
    setActiveVideoUrl(index);
    setIsCarouselAutoPlay(false);
  };

  const handleItemClick = (index: number) => {
    setIsCarouselAutoPlay(false);
    setSelectedIndex(index);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setOverlayVisible(true);
    setIsCarouselAutoPlay(true);
  };
  if (!imageArray?.length) return null;

  return (
    <>
      <Box className="pujaCarouselWrapper">
        <Carousel
          ref={mainCarouselRef}
          responsive={PUJA_INFO_DETAILS_BANNER(imageArray?.length)}
          swipeable
          draggable
          showDots={true}
          keyBoardControl
          infinite
          autoPlay={isCarouselAutoPlay}
          autoPlaySpeed={4000}
          key={imageArray?.length}
          afterChange={handleAfterChange}
          pauseOnHover={false}
        >
          {imageArray.map((item: any, index: number) => {
            const media = item || { pictureUrl: PUJALOADIMG };
            const isVideo = !!media.videoUrl;

            return (
              <Box
                key={media.videoUrl || media.pictureUrl}
                className="pujaImgBlock"
                onClick={() => handleItemClick(index)}
              >
                {!isVideo && (
                  <ImageView
                    src={media.pictureUrl}
                    alt={`Puja Banner ${index + 1}`}
                  />
                )}

                {isVideo && (
                  <Box className="videoBannerSection">
                    <CustomVideoPlayer
                      src={media.videoUrl}
                      isPlaying={activeVideoUrl === index}
                      onClickPlay={(isPlay:boolean) => {
                        if(isPlay){
                          setActiveVideoUrl(index);
                        }else{
                          setActiveVideoUrl(null);
                        }
                        setOverlayVisible(false);
                        setIsCarouselAutoPlay(false);
                      }}
                      onPause={() => {
                        setActiveVideoUrl(null);
                        setOverlayVisible(true);
                        setIsCarouselAutoPlay(true);
                      }}
                      wrapperClass="videoBannerSection"
                      width="100%"
                      height="100%"
                    />

                    {overlayVisible && (
                      <Box
                        className="overlaySec"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOverlayClick(index);
                        }}
                      />
                    )}
                  </Box>
                )}
              </Box>
            );
          })}
        </Carousel>
      </Box>
      {isModalOpen && (
        <ImageModalCarousel
          open={isModalOpen}
          mediaArray={imageArray}
          selectedIndex={selectedIndex}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
}

export default BannerCarouselWithVideo;
